import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as CloseIconSvg } from '../../assets/close-icon.svg';

export const CloseIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={CloseIconSvg} {...props} />;
};
